import { REPORT_STATUS } from './reportStatus';

export type ScreenshotsAction = 'make' | 'remake' | 'download' | null;

export type ScreenshotsKind = 'make' | 'progress' | 'download';

export interface ScreenshotsState {
    kind: ScreenshotsKind;
    label: string;
    action: ScreenshotsAction;
    disabled: boolean;
    hint: string;
    progress?: number;
}

const READY_REPORT: string[] = [
    REPORT_STATUS.FINISHED,
    REPORT_STATUS.STOPPED,
    REPORT_STATUS.ALL_STOPPED,
];

const TOOLTIP =
    'Скриншоты страниц всех найденных источников по всем позициям проекта, zip-архивом. Хранятся 3 месяца';

export function screenshotsStateFor(
    reportStatus: string | undefined,
    shots: { status?: string; found?: number; total?: number } | undefined,
): ScreenshotsState {
    const report = (reportStatus ?? '').toLowerCase();
    const status = (shots?.status ?? 'not_used').toLowerCase();

    if (report === 'screenshotting' || status === 'initial' || status === 'processing') {
        const total = shots?.total ?? 0;
        const found = shots?.found ?? 0;
        const progress = total > 0 ? Math.min(100, Math.round((found / total) * 100)) : undefined;

        return {
            kind: 'progress',
            label: 'Скриншоты',
            action: null,
            disabled: true,
            progress,
            hint: total
                ? `Съёмка идёт: ${found} из ${total}. Архив появится, когда она закончится`
                : 'Съёмка идёт — архив появится, когда она закончится',
        };
    }

    if (status === 'finished') {
        return {
            kind: 'download',
            label: 'Скачать скриншоты',
            action: 'download',
            disabled: false,
            hint: 'Архив готов. Хранится 3 месяца',
        };
    }

    const ready = READY_REPORT.includes(report);

    if (status === 'updating') {
        return {
            kind: 'make',
            label: 'Обновить скриншоты',
            action: 'remake',
            disabled: !ready,
            hint: 'Данные изменились — скриншоты будут пересняты заново',
        };
    }

    return {
        kind: 'make',
        label: 'Сделать скриншот',
        action: 'make',
        disabled: !ready,
        hint: ready ? TOOLTIP : 'Дождитесь окончания поиска',
    };
}